import script from "./LivingPeopleCategory.vue?vue&type=script&lang=ts&setup=true"
export * from "./LivingPeopleCategory.vue?vue&type=script&lang=ts&setup=true"

import "./LivingPeopleCategory.vue?vue&type=style&index=0&id=dfd63064&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd63064"]])

export default __exports__